/**
 * BundeliHub AJAX Add-to-Cart
 * Intercepts all .bh-prod-add buttons and uses fetch API
 * instead of form submission to avoid page reloads.
 */
(function () {
  'use strict';

  // ── Toast Notification ──────────────────────────────────────
  function showToast(message, type) {
    // Remove any existing toast
    const old = document.querySelector('.bh-toast');
    if (old) old.remove();

    const toast = document.createElement('div');
    toast.className = 'bh-toast bh-toast--' + (type || 'success');
    toast.innerHTML =
      '<span class="bh-toast__icon">' + (type === 'error' ? '✕' : '✓') + '</span>' +
      '<span class="bh-toast__msg">' + message + '</span>';
    document.body.appendChild(toast);

    // Trigger animation
    requestAnimationFrame(function () {
      toast.classList.add('bh-toast--show');
    });

    // Auto-dismiss
    setTimeout(function () {
      toast.classList.remove('bh-toast--show');
      setTimeout(function () { toast.remove(); }, 400);
    }, 3000);
  }

  // ── Update cart icon bubble count ───────────────────────────
  function updateCartBubble() {
    fetch(window.routes.cart_url + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.shopify-section');
        var target = document.getElementById('cart-icon-bubble');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* silently fail – bubble count is non-critical */ });
  }

  // ── Open the cart drawer (if present) ───────────────────────
  function openCartDrawer(responseJson) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      // Fetch updated drawer section HTML
      fetch(window.routes.cart_url + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var drawerEl = doc.querySelector('#CartDrawer');
          var target = document.getElementById('CartDrawer');
          if (drawerEl && target) {
            target.innerHTML = drawerEl.innerHTML;
          }
          // Re-bind overlay close
          var overlay = document.getElementById('CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', function () { drawer.close(); });
          drawer.open();
        });
      return;
    }
    // If cart-notification element exists, use it
    var notification = document.querySelector('cart-notification');
    if (notification && typeof notification.renderContents === 'function') {
      // Fetch necessary sections
      fetch(window.routes.cart_url + '?sections=cart-notification-product,cart-notification-button,cart-icon-bubble')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          responseJson.sections = sections;
          notification.renderContents(responseJson);
        });
      return;
    }
    // Fallback – just show toast
    showToast('Added to cart!', 'success');
  }

  // ── AJAX Add to Cart ────────────────────────────────────────
  function ajaxAddToCart(variantId, btn) {
    if (!variantId) return;

    // Set loading state
    btn.classList.add('bh-prod-add--loading');
    btn.disabled = true;

    var body = JSON.stringify({
      id: parseInt(variantId, 10),
      quantity: 1
    });

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) {
          // Error from Shopify (e.g. sold out)
          showToast(data.description || 'Could not add to cart', 'error');
          btn.classList.add('bh-prod-add--error');
          setTimeout(function () { btn.classList.remove('bh-prod-add--error'); }, 600);
        } else {
          // Success
          btn.classList.add('bh-prod-add--success');
          setTimeout(function () { btn.classList.remove('bh-prod-add--success'); }, 1200);
          updateCartBubble();
          openCartDrawer(data);

          // Publish cart update event if pubsub is available
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'bundeli-ajax-cart',
              productVariantId: variantId,
              cartData: data
            });
          }
        }
      })
      .catch(function (err) {
        console.error('BundeliHub AJAX cart error:', err);
        showToast('Something went wrong. Please try again.', 'error');
      })
      .finally(function () {
        btn.classList.remove('bh-prod-add--loading');
        btn.disabled = false;
      });
  }

  // ── Event Delegation ────────────────────────────────────────
  // Use event delegation so dynamically-rendered buttons also work
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bh-prod-add');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    // Get variant ID from data attribute or from a hidden input inside the same card
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) {
      var form = btn.closest('form');
      if (form) {
        var input = form.querySelector('input[name="id"]');
        if (input) variantId = input.value;
      }
    }

    if (variantId) {
      ajaxAddToCart(variantId, btn);
    }
  });

  // Also intercept any form submissions inside bh-prod-card
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.closest || !form.closest('.bh-prod-card')) return;

    e.preventDefault();
    var input = form.querySelector('input[name="id"]');
    var btn = form.querySelector('.bh-prod-add') || form.querySelector('[type="submit"]');
    if (input && btn) {
      ajaxAddToCart(input.value, btn);
    }
  });
})();
